import { useEffect, useRef } from "react";
import { useParams, Navigate } from "react-router-dom";
import { dictionaries, I18nContext, type Lang } from "@/lib/i18n";
import { scrollToId } from "@/lib/scroll";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Releases } from "@/components/Releases";
import { Artists } from "@/components/Artists";
import { Catalog } from "@/components/Catalog";
import { Licensing } from "@/components/Licensing";
import { About } from "@/components/About";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Site() {
  const { lang } = useParams();
  const valid = lang === "en" || lang === "tr";
  const t = valid ? dictionaries[lang as Lang] : dictionaries.en;
  const applyRef = useRef(false);

  useEffect(() => {
    if (!valid) return;
    document.documentElement.lang = lang as string;
    document.title = t.meta.title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", t.meta.description);
  }, [valid, lang, t]);

  if (!valid) return <Navigate to="/en" replace />;

  const goApply = () => {
    applyRef.current = true;
    scrollToId("contact");
  };

  return (
    <I18nContext.Provider value={t}>
      <div
        id="top"
        className="min-h-screen bg-if-black font-sans text-if-text antialiased"
      >
        <Nav lang={lang as Lang} />
        <main>
          <Hero />
          <Marquee />
          <Releases />
          <Artists onApply={goApply} lang={lang as Lang} />
          <Catalog />
          <Licensing />
          <About />
          <Contact lang={lang as Lang} />
        </main>
        <Footer />
      </div>
    </I18nContext.Provider>
  );
}
